import './configure.ts' // Инициализация приложения.
import {AnalyticsBootstrap} from '@frontend/modules/layout/AnalyticsBootstrap'
import {GlobalDataPolling} from '@frontend/modules/layout/GlobalDataPolling'
import {GlobalWebPushSubscriptionHandler} from '@frontend/modules/layout/GlobalWebPushSubscriptionHandler'
import {GlobalWebsocketHandlers} from '@frontend/modules/layout/GlobalWebsocketHandlers'
import {Root} from '@frontend/modules/layout/Root'
import * as ReactDOMClient from 'react-dom/client'

const root = ReactDOMClient.createRoot(document.getElementById('app') as HTMLElement)

/*
 * Монтаж приложения.
 */
root.render(
    <>
        {/*
            Когда-то тут был <StrictMode>, пока я не обнаружил,
            что поведение на prod без него местами не соответствует тому, что с ним.
            Некоторые эффекты, выполняясь 2 раза в StrictMode, исправляют проблему, а
            на prod при этом проблема остается. Это опаснее чем не отмененный запрос к API.
        */}
        <Root />
        {/* Поллинг общих данных. */}
        <GlobalDataPolling key="global-data-polling" />
        {/* Подключение/отключение WebSocket. */}
        <GlobalWebsocketHandlers key="websocket-handlers" />
        {/* Подписка/отписка на Web PUSH. */}
        <GlobalWebPushSubscriptionHandler key="web-push-subscription" />
        {/* Загрузка скриптов аналитики после монтирования SPA (защита от iOS Content Blocker). */}
        <AnalyticsBootstrap key="analytics-bootstrap" />
    </>
)
